export default __webpack_public_path__ + "static/media/15_gallery.6fee3257.jpg";